import React, { Component, ReactNode } from 'react'
import ReactDOM from 'react-dom/client'
import './index.scss'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import 'bootstrap/dist/js/bootstrap.min'
import Login from './Pages/Login/Login'
import { Provider } from 'react-redux'
import { store } from './redux/store'
import ForgotPassword from './Pages/ForgotPassword/ForgotPassword'
import ScrollToTop from './Components/ScrollToTop/ScrollToTop'
import ResetPassword from './Pages/ResetPassword/ResetPassword'
import Welcome from './Pages/Welcome/Welcome'
import {EULA_PATH, PRIVACY_POLICY_PATH, SUPPORT_PATH, TERMS_OF_SERVICE_PATH} from "./utils/const";
import PrivacyPolicy from "./Pages/InformationPages/PrivacyPolicy/PrivacyPolicy";
import TermsOfService from "./Pages/InformationPages/Terms/Terms";
import EULA from "./Pages/InformationPages/EULA/EULA";
import Support from "./Pages/Support/Support";

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

class ProtectedRoute extends Component<{ children: ReactNode }> {
  render() {
    let { children } = this.props

    const token = localStorage.getItem('token')

    if (!token) {
      return <Navigate to="/welcome" replace />
    }

    return children
  }
}

root.render(
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route
          path="/*"
          index
          element={
            <ProtectedRoute
              children={
                <Provider store={store}>
                  <App />
                </Provider>
              }
            />
          }
        />
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/getaccess" element={<Login />} />
        {/*<Route path="/registration" element={<Registration />} />*/}
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path={PRIVACY_POLICY_PATH} element={<PrivacyPolicy />} />
        <Route path={TERMS_OF_SERVICE_PATH} element={<TermsOfService />} />
        <Route path={EULA_PATH} element={<EULA />} />
        <Route path={SUPPORT_PATH} element={<Support />} />
      </Routes>
    </BrowserRouter>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
